export default "__VITE_ASSET__6zyNJ7uJ__"